module.exports = __webpack_public_path__ + "static/media/videovisit-grayicon.de080162.svg";